import { Box } from "@mui/material";
import Notification from "./Notification";
import AccountPopover from "./AccountPopOver";
import { useState, useEffect } from "react";
import secureLocalStorage from "react-secure-storage";

const AppBar = () => {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const userRole = secureLocalStorage.getItem("role");
    console.log(userRole);
    setRole(userRole);
  }, []);
  return (
    <>
      {role == undefined || role == null ? null : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 1.4,
            background: "var(--dark-purple)",
          }}
        >
          {role === "admin" && (
            <Box sx={{ marginRight: "1vw" }}>
              <Notification />
            </Box>
          )}
          <Box sx={{ marginRight: "0.4vw" }}>
            <AccountPopover role={role} />
          </Box>
        </Box>
      )}
    </>
  );
};

export default AppBar;
